export const usStateOptions = [
  { label: 'Alabama (AL)', value: 'AL' },
  { label: 'Alaska (AK)', value: 'AK' },
  { label: 'Arizona (AZ)', value: 'AZ' },
  { label: 'Arkansas (AR)', value: 'AR' },
  { label: 'California (CA)', value: 'CA' },
  { label: 'Colorado (CO)', value: 'CO' },
  { label: 'Connecticut (CT)', value: 'CT' },
  { label: 'Delaware (DE)', value: 'DE' },
  { label: 'Florida (FL)', value: 'FL' },
  { label: 'Georgia (GA)', value: 'GA' },
  { label: 'Hawaii (HI)', value: 'HI' },
  { label: 'Idaho (ID)', value: 'ID' },
  { label: 'Illinois (IL)', value: 'IL' },
  { label: 'Indiana (IN)', value: 'IN' },
  { label: 'Iowa (IA)', value: 'IA' },
  { label: 'Kansas (KS)', value: 'KS' },
  { label: 'Kentucky (KY)', value: 'KY' },
  { label: 'Louisiana (LA)', value: 'LA' },
  { label: 'Maine (ME)', value: 'ME' },
  { label: 'Maryland (MD)', value: 'MD' },
  { label: 'Massachusetts (MA)', value: 'MA' },
  { label: 'Michigan (MI)', value: 'MI' },
  { label: 'Minnesota (MN)', value: 'MN' },
  { label: 'Mississippi (MS)', value: 'MS' },
  { label: 'Missouri (MO)', value: 'MO' },
  { label: 'Montana (MT)', value: 'MT' },
  { label: 'Nebraska (NE)', value: 'NE' },
  { label: 'Nevada (NV)', value: 'NV' },
  { label: 'New Hampshire (NH)', value: 'NH' },
  { label: 'New Jersey (NJ)', value: 'NJ' },
  { label: 'New Mexico (NM)', value: 'NM' },
  { label: 'New York (NY)', value: 'NY' },
  { label: 'North Carolina (NC)', value: 'NC' },
  { label: 'North Dakota (ND)', value: 'ND' },
  { label: 'Ohio (OH)', value: 'OH' },
  { label: 'Oklahoma (OK)', value: 'OK' },
  { label: 'Oregon (OR)', value: 'OR' },
  { label: 'Pennsylvania (PA)', value: 'PA' },
  { label: 'Rhode Island (RI)', value: 'RI' },
  { label: 'South Carolina (SC)', value: 'SC' },
  { label: 'South Dakota (SD)', value: 'SD' },
  { label: 'Tennessee (TN)', value: 'TN' },
  { label: 'Texas (TX)', value: 'TX' },
  { label: 'Utah (UT)', value: 'UT' },
  { label: 'Vermont (VT)', value: 'VT' },
  { label: 'Virginia (VA)', value: 'VA' },
  { label: 'Washington (WA)', value: 'WA' },
  { label: 'West Virginia (WV)', value: 'WV' },
  { label: 'Wisconsin (WI)', value: 'WI' },
  { label: 'Wyoming (WY)', value: 'WY' },
];

export const shippingMethodOptions = [
  { label: 'UPS', value: 100000000 },
  { label: 'Fedex', value: 100000001 },
  { label: 'Customer Pickup', value: 100000002 },
  { label: 'Customer Pickup GAC', value: 100000006 },
  { label: 'TOG Delivery', value: 100000003 },
  { label: 'Courier', value: 100000004 },
  { label: 'Export', value: 100000005 },
  { label: 'Discard', value: 100000008 },
];

export const billStatusOptions = [
  { label: 'Do Not Bill', value: 100000000 },
  { label: 'Billed', value: 100000001 },
  { label: 'Pulled', value: 100000002 },
];
export const shipmentCategoryOptions = [
  { label: 'TOG', value: 100000000 },
  { label: 'Progentus', value: 100000001 },
  { label: 'Terminal Beef Embryos', value: 100000002 },
];

export const colorMap: Record<string, string> = {
  'bg-blue-100': '#dbeafe',
  'bg-green-100': '#dcfce7',
  'bg-yellow-100': '#fef9c3',
  'bg-purple-100': '#f3e8ff',
  'bg-pink-100': '#fce7f3',
  'bg-indigo-100': '#e0e7ff',
  'bg-red-100': '#fee2e2',
  'bg-orange-100': '#ffedd5',
  'bg-teal-100': '#ccfbf1',
  'bg-cyan-100': '#cffafe',
};

export const highlightColors = Object.keys(colorMap);
